import { createRouter, createWebHistory } from 'vue-router'
import { booksRoutes } from './modules/books'

const routes = [

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  ...booksRoutes

]

import { useAuthStore } from '../stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
    const authStore = useAuthStore()
    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        next('/login')
    } else {
        next()
    }
})

export default router